import { useTranslation } from '@chr/online-shared-ui-localizations';
import Grid from '@mui/material/Grid';
import { Stop } from '../../common/apis/dtos';
import { ItemDetailsInfo } from './ItemDetailsInfo';
import '../../common/utilities/Section.scss';
import { FormatLocation } from '../../common/utilities/display-utilities';

export enum ItemDetailsType {
  PickUp = 'pickUp',
  DeliverTo = 'deliverTo',
}

declare interface ItemDetailsSummaryProps {
  isMobileScreen: boolean;
  itemDetailsType: ItemDetailsType;
  stopInfo: Stop;
}

export const ItemDetailsSummary = ({
  isMobileScreen,
  itemDetailsType,
  stopInfo,
}: ItemDetailsSummaryProps) => {
  const translate = useTranslation();
  const location = FormatLocation(stopInfo.location);

  const item = () => {
    return (
      <Grid
        container
        spacing={2}
        className="item-summary-section"
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
      >
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ItemDetailsInfo
            title={translate('Number of Items')}
            information={stopInfo.numberOfItems ? stopInfo.numberOfItems : 0}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ItemDetailsInfo
            title={translate('Quantity')}
            information={stopInfo.quantity ? stopInfo.quantity.toFixed(2) : 0}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ItemDetailsInfo
            title={translate('Total Weight')}
            information={ stopInfo.totalWeight?.standard ? stopInfo.totalWeight?.standard.toFixed(2) + ' lbs' : 0 }
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ItemDetailsInfo
            title={translate('Pallets')}
            information={stopInfo.pallets?.toFixed(2)}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <div data-testid="item-details-summary" className="section">
      <div className="section-heading">
        {itemDetailsType == ItemDetailsType.PickUp ? translate('Pickup from ') + location : translate('Deliver to ') + location}
      </div>
      <div className={isMobileScreen ? 'section-body-mobile' : 'section-body'}>
        {item()}
      </div>
    </div>
  );
};
